import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {SaveConflictPanelProps} from '@Panels/save-conflict-panel/save-conflict-panel';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'save-conflict-modal-panel';

export type SaveConflictModalProps = SaveConflictPanelProps;

export default function SaveConflictModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SAVE_CONFLICT_MODAL];
  });

  const height = 'fit-content';
  const width = '680px';

  return (
    <Modal modalId={MODALS_IDS.SAVE_CONFLICT_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="save-conflict-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSaveConflictModal = (props: SaveConflictModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SAVE_CONFLICT_MODAL,
      panelProps: props,
    })
  );
};
